import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { AppointmentService } from "@app/shared/services/appointment.service";
import * as moment from "moment-timezone";
import swal from "sweetalert2";
import { AuthenticationService } from "@app/shared/services/authentication.service";
import { TechAnalystScheduleService } from "@app/feature/main/tech-analyst/shared/services/tech-analyst-schedule.service";
import { BreadcrumService } from "@app/shared/services/breadcrum.service";
import { MixpanelEventLoggingService } from "@app/shared/services/mixpanel-event-logging.service";
import { AnalystProfileService } from '@app/feature/main/tech-analyst/shared/services/analyst-profile.service';
declare var $: any;
@Component({
  selector: "app-schedule-call-list",
  templateUrl: "./schedule-call-list.component.html",
  styleUrls: ["./schedule-call-list.component.css"]
})
export class ScheduleCallListComponent implements OnInit {
  selecteddate: Date;
  value: Date;
  allAppointmentList: any = [];
  upcomingAppointmentList: any = [];
  userProfileData: any = {};
  userRole: any;
  minDate = new Date();
  showArchives: boolean = false;
  archiveDetails: any = [];
  selectedIndex: any = 0;
  showCancelMeetingButton: boolean;
  callButtonActive: boolean;
  userId : string;
  calendarLoginStatus : boolean;
  constructor(
    private router: Router,
    private breadcrumService:BreadcrumService,
    private appointmentService: AppointmentService,
    private authenticationService: AuthenticationService,
    private techAnalystScheduleService: TechAnalystScheduleService,
    private mixpanelEventLoggingService: MixpanelEventLoggingService,
    private analystProfileService: AnalystProfileService
  ) {
    this.value = new Date();
  }

  ngOnInit() {
    if (window.sessionStorage.getItem('userDetails')) {
      this.userId = JSON.parse(window.sessionStorage.getItem('userDetails')).id;
    }
    this.getRole();
    this.initAppointments();
    // this.getMicrosoftLoginStatus(this.userId);
  }
  initAppointments() {
    this.getAllMyAppointment('all');
    this.getAllMyAppointment('upcoming');
  }
  refreshSnapShotAPI() {
    //this.callInitApis();
  }
  getAllMyAppointment(status: any) {
    this.appointmentService.getAppointmentList(status).subscribe(
      (results: any) => {
        if (status === 'all') {
          this.allAppointmentList = results;
        } else {
          this.upcomingAppointmentList = results;
        }
        if (results.length > 0) {
          this.userProfileData = results[0];
          this.selectedIndex = results[0].id;
          //  FIX: cancel-meeting button initialization
          this.meetingCancelButton();
          this.callButton();
        } else {
          this.userProfileData = [];
        }
      },
      error => {
        swal("Info", error.error.error.message, "info");
      }
    );
  }

  // call now button disable
  callButton() {
    const scheduleDate = new Date(this.userProfileData.endTime);
    const currentTime = new Date(moment.utc().format());
    this.callButtonActive = scheduleDate >= currentTime  ? true : false;
  }

  showProfileData(index, status) {
    this.showArchives = false;
    this.userProfileData = status === 'all' ? this.allAppointmentList[index] : this.upcomingAppointmentList[index];
    this.selectedIndex = this.userProfileData.id;

    //  FIX: redirecting to cancel meeting button hide
    this.meetingCancelButton();
    this.callButton();
  }

  //  FIX: cancel meeting button hide function
  meetingCancelButton() {
    const scheduleDate = new Date(this.userProfileData.endTime);
    if (this.userProfileData.status !== 'cancelled') {
      this.showCancelMeetingButton = scheduleDate >= this.minDate ? true : false;
    } else {
      this.showCancelMeetingButton = false;
    }
  }

  routeTechAnalystProfilePage(analystId: string,firstName,lastName) {
    this.breadcrumService.setUrl('BC3Label',firstName + ' ' + lastName);

    this.router.navigate(["analyst-profile"], {
      queryParams: { analystId: analystId }
    });
  }
  getRole() {
    if (this.authenticationService.getRole() == "tech_analyst") {
      this.userRole = "tech_analyst";
      this.getMicrosoftLoginStatus(this.userId);
    } else {
      this.userRole = "tech-vendor";
    }
  }
  // disable call canecl feature for production release
  deleteConfirm(id , nameObj) {
    const name = nameObj.firstName+ " "+ nameObj.lastName;
    swal({
      title: "Cancel Meeting?",
      // text: "Are you sure you want to cancel the meeting?",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      buttonsStyling: false
    }).then((result: any) => {
      if (result.value) {
        this.appointmentDelete(id, name);
      }
    });
  }
  appointmentDelete(id , name) {
    this.appointmentService.deleteAppointment(id).subscribe(
      (res: any) => {
        this.mixpanelEventLoggingService.dispatchEvent("cancel call", {
          "Tech Analyst": name ? name : '',
        });
        this.mixpanelEventLoggingService.dispatchEvent("cancel call", {
          "Re-imbursed Event": "Meeting cancellation",
        });
        this.initAppointments();
      },
      error => {
        swal("Info", error.error.error.message, "info");
      }
    );
  }
  getArchives(id) {
    this.appointmentService
      .getArchives(id)
      .subscribe(
        (resp: any) => {
          this.archiveDetails = resp;
          this.showArchives = true;
        },
        error => {
          swal("Info", error.error.error.message, "info");
        }
      );
  }
  navScheduleMeeting() {

    this.breadcrumService.setUrl('BC3Label','Analyst list');
    this.breadcrumService.setUrl('BC3Url','analyst-list');
    this.router.navigate(["analyst-list"]);
  }
  microsoftLogin(event: any) {
    this.techAnalystScheduleService.msAuth().subscribe((authRsp: any) => {
      window.open(authRsp.authUrl, "_self");
    }, error => {

    });
  }
  getMicrosoftLoginStatus(userId){
    this.analystProfileService.getAnalystDetails(userId).subscribe((response)=>{
      this.calendarLoginStatus = response['calendarLoginStatus'];
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/schedule-call-list/schedule-call-list.component.ts